import {BLIState, State} from '../states';

export const complete = (state: BLIState, getters: unknown, rootState: State): boolean => {
  return (state.answers.id !== undefined && state.answers.id !== null) ||
      (rootState.package.policies?.liability?.liability?.id !== undefined && rootState.package.policies.liability.liability.id !== null);
};
